import React from 'react';
import {Col, Row} from 'antd';

import children from 'images/photo/children.jpg';

import styles from './stockInformation.module.scss';
import {useSelector} from 'react-redux';
import {getAppSettings} from 'app/reducers/commonData/selectors';

const CharityEventDescription: React.FC = () => {
    const appSettings = useSelector(getAppSettings);

    return (
        <Row className={styles.block}>
            <Col sm={24} md={12}>
                <div className={styles.information_card}>
                    <h2 className={styles.title}>
                        Благодійна акція <br />
                        "Стань Чарівником"
                    </h2>
                    <p>Щороку фонд «Доброта та Довіра» допомагає дітям отримати подарунки до Дня Святого Миколая.</p>
                    <p>
                        <strong>
                            За останні {appSettings?.projectYears} років ми здійснили {appSettings?.allGiftsCount}{' '}
                            дитячих мрій. Серед них - мрії дітей з інвалідністю, дітей-сиріт та дітей, які живуть із
                            важкими захворюваннями.
                        </strong>
                    </p>
                    <p>Навіть під час війни ми продовжуємо дарувати добро - адже дитячі мрії не мають канікул.</p>
                    <p>Долучайся та стань частиною цього дива. Обери дитячу мрію та допоможи їй здійснитися.</p>

                    <img src={children} alt="children" className={styles.photo} />
                </div>
            </Col>
            <Col sm={24} md={12}>
                <div className={styles.videoColumn}>
                    <iframe
                        className={styles.youtubeVideo}
                        src="https://www.youtube.com/embed/4DnqbHgl7wo?autoplay=false&mute=1"
                        title="Доброта та довіра"
                        frameBorder="0"
                        allow="encrypted-media; picture-in-picture"
                        allowFullScreen
                    />
                </div>
            </Col>
        </Row>
    );
};

export default CharityEventDescription;
